///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import Spinner from "../../icons/Spinner";
import ErrorIcon from "../../icons/ErrorIcon";
import messages from "../../../helpers/messages";

export const LoadingErrorState = ({ loading, error }) => {
  return (
    <div className="p-16 box text-center">
      {loading && (
        <Spinner
          height="36px"
          width="36px"
          className="spinner"
          fill="#C9CACC"
        />
      )}
      {error && (
        <div>
          <ErrorIcon height="36px" width="36px" fill="#C9CACC" />
          <p data-testid="error-message" className="text-light-grey pt-2">
            {messages.pleaseRefreshThePage.defaultMessage}
          </p>
        </div>
      )}
    </div>
  );
};

export default LoadingErrorState;
